import { ToggleModal } from '../../types';

type HandleBackClick = {
  currentModalIndex: number | null;
  setWidgetInactive: () => void;
  toggleModal: ToggleModal;
};

const handleBackClick = ({ currentModalIndex, setWidgetInactive, toggleModal }: HandleBackClick) => {
  if (currentModalIndex !== null && currentModalIndex > 0) {
    toggleModal(currentModalIndex, false);
    toggleModal(currentModalIndex - 1, true);
  }

  if (currentModalIndex === 0 || currentModalIndex === null) {
    setWidgetInactive();
  }
};

export default handleBackClick;
